<ngx-spinner [name]="spinner1" [fullScreen]="true"><span class="badge badge-info p-2">Autorisierung wird durchgeführt...</span></ngx-spinner>
<div aria-labelledby="swal2-title" aria-describedby="swal2-content" class="swal2-popup swal2-modal swal2-show" tabindex="-1" role="dialog" aria-live="assertive" aria-modal="true" style="display: flex;">
  <div class="swal2-header">
    <div class="swal2-icon swal2-warning swal2-icon-show" style="display: flex;">
      <div class="swal2-icon-content">!</div>
    </div>
    <h2 class="swal2-title" id="swal2-title" style="display: block;" i18n="@@AreYouSure?Header">Sind Sie sicher?</h2>
  </div>

  <div class="swal2-content swal2-html-container" i18n="@@DeleteUserWarningMessage">
    {{getDeleteText()}}
  </div>

  <div class="swal2-actions">
    <div class="swal2-loader"></div>
    <button type="submit" id="delete_user" class="btn btn-danger button-margin" (click)="onConfirmClick()" aria-label="" i18n="@@ConfirmDeleteUserButton">{{getDelButtonText()}}</button>
    <button type="button" id="cancel" class="btn btn-yellow button-margin" (click)="onCancelClick()" ngbAutofocus aria-label="" i18n="@@CancelButton">Abbrechen</button>
  </div>
</div>
